import { siteInfo } from '@/mocks/siteInfo';

interface JsonLdProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList';
  data: Record<string, unknown>;
}

export default function JsonLd({ type, data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': type,
          ...data,
        }),
      }}
    />
  );
}

export function getOrganizationSchema() {
  return {
    type: 'Organization' as const,
    data: {
      name: siteInfo.name,
      url: siteInfo.domain,
      logo: `${siteInfo.domain}/logo.png`,
      description: siteInfo.description,
      email: siteInfo.email,
      telephone: siteInfo.phone,
      address: {
        '@type': 'PostalAddress',
        streetAddress: siteInfo.address,
        addressCountry: 'CN',
      },
      sameAs: [
        'https://weibo.com/555dy',
        'https://www.bilibili.com/555dy',
      ],
    },
  };
}

export function getWebsiteSchema() {
  return {
    type: 'WebSite' as const,
    data: {
      name: siteInfo.name,
      url: siteInfo.domain,
      description: siteInfo.description,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteInfo.domain}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
  };
}

export function getWebPageSchema(name: string, description: string, url: string) {
  return {
    type: 'WebPage' as const,
    data: {
      name,
      description,
      url,
      isPartOf: {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.domain,
      },
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    type: 'BreadcrumbList' as const,
    data: {
      itemListElement: items.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: item.url,
      })),
    },
  };
}